import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import loader from "./Common/loader/reducer";
import snackbar from "./Common/snackbar/reducer";
import login from "./Auth/Reducer";
import exec from "./Pages/Executive/Reducer";
import client from "./Pages/Client/Reducer";
import model from "./Pages/Model/Reducer";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  loader,
  snackbar,
  login,
  exec,
  client,
  model,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };
